import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  noteDialog: {
    width: 600,
  },
  noteDialogInput: {
    paddingBottom: 10,
  },
}));

export default useStyles;